import { radioCatalog } from '@/lib/supported-radios'

export type Feature = {
  title: string
  description: string
  icon: string
  href?: string
}

export const features: Feature[] = [
  {
    title: 'Hundreds of Radios',
    description:
      'Program memory channels, names, tones, and settings across a huge catalog of amateur, GMRS, and commercial radios from dozens of manufacturers.',
    icon: 'radio',
    href: '/#radios',
  },
  {
    title: 'Cross-Platform',
    description:
      'Native builds for Windows, macOS, and Linux. The same familiar interface everywhere you work, no matter your setup.',
    icon: 'monitor',
    href: '/#download',
  },
  {
    title: 'Copy Between Radios',
    description:
      'Load a memory layout from one radio and drop it straight into another. Mix and match sources with simple copy and paste.',
    icon: 'copy',
  },
  {
    title: 'Import & Export',
    description:
      'Work with CSV files, spreadsheets, and repeater directories. Bring in data from RadioReference and other community sources.',
    icon: 'file',
  },
  {
    title: 'Free & Open Source',
    description:
      'Built on the foundation of the classic CHIRP project, NewChirp carries on its free, GPL-licensed spirit. No accounts, no paywalls, no lock-in.',
    icon: 'heart',
  },
  {
    title: 'Community Driven',
    description:
      'New radios and fixes land constantly thanks to an active community of hams contributing drivers, bug reports, and test data.',
    icon: 'users',
  },
]

export const stats = [
  { label: 'Supported models', value: String(radioCatalog.totalModels) },
  { label: 'Brands', value: String(radioCatalog.totalBrands) },
  { label: 'Cost, forever', value: '$0' },
  { label: 'Month in service', value: '1' },
]

export const steps = [
  {
    number: '01',
    title: 'Download & Install',
    description:
      'Grab the latest build for your operating system. Windows and macOS have installers; Linux users can use the Flatpak or run from source.',
  },
  {
    number: '02',
    title: 'Connect Your Radio',
    description:
      'Plug in your programming cable and install the driver if needed. Power on the radio and note which serial port it appears on.',
  },
  {
    number: '03',
    title: 'Download From Radio',
    description:
      'Use Radio → Download From Radio, pick your vendor and model, and NewChirp reads the current memory image directly from the device.',
  },
  {
    number: '04',
    title: 'Edit & Upload',
    description:
      'Edit channels, tones, and settings in the grid, then Upload To Radio to write your changes back. Always keep a backup image first.',
  },
]
